"use client"

import { ColumnDef } from "@tanstack/react-table"

export type UserColumns = {
  id: string
  fullName: string
  email?: string | null
  createdAt?: string | null
  searchKeywords: Array<{ id: string; keyword: string }>
  waitlistEntry?: { keywords?: string | null } | null
}

export function buildColumns(
  onSelect: (id: string) => void,
  onEditKeywords: (id: string) => void
): ColumnDef<UserColumns | null | undefined>[] {
  return [
    {
      accessorKey: "fullName",
      header: "Name",
      cell: ({ row }) => {
        return (
          <button
            className="text-left hover:underline"
            onClick={() => row.original?.id && onSelect(row.original.id)}
          >
            <div className="text-sm">{row.getValue("fullName")}</div>
            <div className="text-gray-500">{row.original?.email}</div>
          </button>
        )
      },
    },
    {
      accessorKey: "createdAt",
      header: "Created at",
    },
    {
      id: "actions",
      cell: ({ row }) => {
        if (!row.original?.id) return null
        return (
          <button
            className="text-xs text-stone-500 hover:text-stone-900 underline"
            onClick={() => onEditKeywords(row.original!.id)}
          >
            Edit keywords
          </button>
        )
      },
    },
  ]
}
